import {combineReducers} from 'redux';
import ACTION from '../action_constant';

function shipment(state = {
  shipmentDetails: ''
}, action) {
  let shipmentDetails, questions, newQuestions, makeOffer;
  switch (action.type) {
    case ACTION.SHIPMENT.ADD_SHIPMENT_DETAILS:
      return Object.assign({}, state, {shipmentDetails:action.data});

    case ACTION.SHIPMENT.ADD_NEW_Q_A:
            shipmentDetails = Object.assign({} ,state);
            questions = shipmentDetails.shipmentDetails.questions;
            newQuestions = [...questions,...action.data.questions];
            shipmentDetails.shipmentDetails.questions = newQuestions;
        return Object.assign({},state,{shipmentDetails :shipmentDetails.shipmentDetails });

     case ACTION.SHIPMENT.ANSWER_A_QUESTION:
            shipmentDetails = Object.assign({} ,state);
            questions = shipmentDetails.shipmentDetails.questions;
            questions.forEach((question)=>{
              if(question.questionId == action.data.questionId)
              {
                question.answer = action.data.answer;
                question.isAnswered = true;
              }
            })
          return Object.assign({},state,{shipmentDetails :shipmentDetails.shipmentDetails });

       case ACTION.SHIPMENT.FLAG_A_QUESTION:
            shipmentDetails = Object.assign({} ,state);
            questions = shipmentDetails.shipmentDetails.questions;
            questions.forEach((question)=>{
              if(question.questionId == action.data.questionId)
              {
                question.isQuestionFlagged = true;
              }
            })
            return Object.assign({},state,{shipmentDetails :shipmentDetails.shipmentDetails });

    default:
      return state;
  }
}

module.exports = shipment;



// WEBPACK FOOTER //
// app/shipment/shipment_reducers.jsx